import { Component, Input } from '@angular/core';

import { Style, Widget, WidgetContent } from '@core/models';

import { ContentComponent } from '@shared/components/contents/content.component';
import { ColorsEnum } from '@core/models/enums/colors.enum';

@Component({
  selector: 'shared-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent implements ContentComponent {
  @Input() public widget: Widget;

  private defaultAlign: 'center' | 'flex-start' | 'flex-end' = 'flex-start';
  private defaultJustify: 'center' | 'flex-start' | 'flex-end' = 'flex-start';
  private defaultColor: ColorsEnum = ColorsEnum.BLACK;
  private defaultPadding: string = '1rem';
  private defaultMargin: string = '0';
  private defaultTextAlign: 'left' | 'right' | 'center' | 'justify' = 'left';
  private defaultMaxWidth: string = 'auto';

  public get contentWidget(): WidgetContent {
    return this.widget?.content;
  }

  public get content(): string {
    return this.contentWidget?.content as string;
  }

  public get contentStyle(): Style {
    return this.contentWidget?.style;
  }

  public get cardStyle(): { [key: string]: string } {
    return {
      backgroundColor: this.contentStyle.backgroundColor,
    };
  }

  public get style(): { [key: string]: string } {
    return {
      alignItems: this.contentStyle.align || this.defaultAlign,
      justifyContent: this.contentStyle.justify || this.defaultJustify,
      color: this.contentStyle.color || this.defaultColor,
      padding: this.contentStyle.padding || this.defaultPadding,
      margin: this.contentStyle.margin || this.defaultMargin,
      textAlign: this.contentStyle.textAlign || this.defaultTextAlign,
      maxWidth: this.contentStyle.maxWidth || this.defaultMaxWidth,
    };
  }
}
